import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { environment } from 'src/environments/environment';
import { RouteReuseStrategy } from '@angular/router';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { TokenStorageService } from '../_services/token-storage.service';

const AUTH_API = environment.prismaApiUrl + '/api/auth/';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, public afAuth: AngularFireAuth, public router: Router, private tokenStorage: TokenStorageService) { }

  login(email: string, password: string, otp?: string): Observable<any> {
    const body: { email: string; password: string; otp?: string } = { email, password };
    if (otp != null && String(otp).trim() !== '') {
      body.otp = String(otp).trim();
    }
    return this.http.post(AUTH_API + 'dispo/login', body, httpOptions);
  }

  logout(): Observable<any> {
    return this.http.post(AUTH_API + 'logout', {
     
    }, httpOptions);
  }

  refreshToken(): Observable<{ access_token: string; token_type?: string; expires_in?: number }> {
    const token = this.tokenStorage.getToken();
    const headers = token
      ? new HttpHeaders({
          Authorization: `Bearer ${token}`,
        })
      : httpOptions.headers;

    return this.http.post<{ access_token: string; token_type?: string; expires_in?: number }>(
      AUTH_API + 'refresh',
      {},
      { headers }
    );
  }

  /** Deaktiviert – Benutzer werden nur durch Administratoren angelegt. */
  register(_username: string, _email: string, _password: string): Observable<never> {
    throw new Error('Registrierung ist deaktiviert.');
  }

  checkToken(): void {
    const token = this.tokenStorage.getToken(); // Annahme: Das Token wird im localStorage gespeichert.
    if (!token) {
      alert('Token fehlt. Sie werden zum Login-Bildschirm weitergeleitet.');
      //this.router.navigate(['/login']); // Login-Bildschirm muss im Routing definiert sein.
    }
  }

   // Facebook login
   doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.FacebookAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Github login
  doGitHubLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GithubAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Twitter login
  doTwitterLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.TwitterAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Google login
  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Register
  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(value.email, value.password)
        .then(
          res => {
            resolve(res);
          },
          err => reject(err)
        );
    });
  }

  // Login
  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(value.email, value.password)
        .then(
          res => {
            resolve(res);
          },
          err => reject(err)
        );
    });
  }

  // Logout (API-Protokoll + lokale Session beenden)
  doLogout() {
    return new Promise<void>((resolve) => {
      const clearLocal = () => {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('remember');
        this.tokenStorage.signOut();
        if (firebase.auth().currentUser) {
          this.afAuth.auth.signOut();
        }
      };

      const token = this.tokenStorage.getToken();
      if (token) {
        this.logout().subscribe({
          next: () => {
            clearLocal();
            resolve();
          },
          error: () => {
            clearLocal();
            resolve();
          }
        });
        return;
      }

      clearLocal();
      resolve();
    });
  }
}
